module.exports = __webpack_public_path__ + "images/emoji/battery.5ff784b5ce782caa3ac3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/battery.png
// module id = EEEz
// module chunks = 13